import { PostInvestorDraftInstanceRes } from '@dealstack/shared/lib/generated';
import { Table } from '@dealstack/frontend/shared/components/Table/Table/Table';
import { useSecurityTable } from '@dealstack/frontend/shared/components/Investors/Substeps/SecurityTable/useSecurityTable';

interface Props {
	investors?: PostInvestorDraftInstanceRes[];
}

export const SecurityTable = ({ investors }: Props) => {
	const { tableInstance } = useSecurityTable(investors);

	return (
		<div className="mt-10">
			<Table tableInstance={tableInstance} />
		</div>
	);
};
